import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { OTHER_INCOME_TYPE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import OtherIncomeYearFieldsForm from './OtherIncomeYearFieldsForm';

const NonOperationIncomeForm = () => {
  const { otherIncome } = useIncomeStructure();

  const nonOperationIncome = findMasterDataById(
    otherIncome,
    OTHER_INCOME_TYPE_ID.NON_OPERATIONS
  );

  return (
    <>
      {nonOperationIncome && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }} required>
              {nonOperationIncome.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (พันบาท)
            </Typography>
          </Box>
          <OtherIncomeYearFieldsForm
            keyItem={nonOperationIncome.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default NonOperationIncomeForm;
